import { render, staticRenderFns } from "./CreateCollectionDialog.vue?vue&type=template&id=74efc2c9&scoped=true&lang=true"
import script from "./CreateCollectionDialog.vue?vue&type=script&lang=js"
export * from "./CreateCollectionDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCollectionDialog.vue?vue&type=style&index=0&id=74efc2c9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efc2c9",
  null
  
)

export default component.exports